import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getLearningZoneCourses } from '../../../api';

const EMPTY = { categories: [], subcategories: [], builtInRows: [], categoryGroups: [], hiddenRows: [], hiddenCategories: [] };

/**
 * The task types of the published courses, by category, the subcategories
 * admins added, the built-in rows courses are placed in and the categories
 * admins added (each with its chapters), and the built-in rows / categories
 * admins deleted (`hiddenRows`, `hiddenCategories`), loaded for the logged-in student
 * when the page opens.
 * Empty while loading or if the request fails, so the sidebar then shows
 * exactly its usual rows.
 * Loaded again (keeping the current rows meanwhile) on each navigation to the
 * page while it is open, e.g. clicking a "New Lesson Added" notification there.
 */
export default function useLearningZoneCourses() {
  const [rows, setRows] = useState(EMPTY);
  const { key: locationKey } = useLocation();

  useEffect(() => {
    let cancelled = false;
    const studentId = localStorage.getItem('userId');
    if (!studentId) return undefined;

    const load = async () => {
      try {
        const data = await getLearningZoneCourses(studentId);
        if (!cancelled) {
          setRows({
            categories: data?.categories || [],
            subcategories: data?.subcategories || [],
            builtInRows: data?.builtInRows || [],
            categoryGroups: data?.categoryGroups || [],
            hiddenRows: data?.hiddenRows || [],
            hiddenCategories: data?.hiddenCategories || [],
          });
        }
      } catch (error) {
        console.error('Failed to load Learning Zone courses:', error);
      }
    };
    load();

    return () => {
      cancelled = true;
    };
  }, [locationKey]);

  return rows;
}
